<template lang="pug">
  div.page
    .forget-password-form
      h1.big-section-heading.main-heading {{ $t('forgotPassword.heading') }}
      label
        h4.label-heading {{ $t('forgotPassword.email') }}
        input.square-input(v-model='email', type='email', :placeholder='$t("forgotPassword.email")', @keyup.enter='forgotPassword')
      router-link.button.button--gray-outline(to='/login') {{ $t('forgotPassword.back') }}
      button.button.button--blue(@click="forgotPassword") {{ $t('forgotPassword.button') }}
</template>

<script>
import auth0Service from '@/services/auth0'
import card from '@/components/common/card.vue'

export default {
  components: { card },
  data: () => ({
    email: ''
  }),
  methods: {
    clearForm () {
      this.email = ''
    },
    async forgotPassword () {
      this.$ga.event('Button', 'Clicked', `Forgot Password ${this.$i18n.locale.toUpperCase()}`)
      try {
        this.$store.dispatch('startTask', { id: 'forgot' })
        await auth0Service.resetPassword({
          email: this.email
        })
        this.$notify({ group: 'general', type: 'success', title: 'Success', text: 'We sent you an email with a link to reset your password!', duration: -1 })
        this.clearForm()
        this.$ga.event('Forgot Password', 'Success', 'Successful Password Change')
        this.$store.dispatch('endTask', { id: 'forgot' })
      } catch (error) {
        console.error(error)
        this.$store.dispatch('clearTasks')
        this.$ga.event('Forgot Password', 'Error', error.message)
        this.$notify({ group: 'general', type: error.type || 'error', title: error.title, text: error.message, duration: -1 })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/scss/abstract/variables.scss';

  .page {
    margin: 0 auto;
  }

  .forget-password-form {
    padding: 3em;
    width: 100%;
    max-width: 500px;
    text-align:center;
    margin: 0 auto;
  }
  .card {
    background: transparent;
  }
  .main-content {
    background: $blue;
  }
  .main-heading {
    margin: 0 0 0.3em 0;
    color: $blue;
    font-weight: 400;
    text-transform: none;

    @media only screen and (max-width: $mobile) {
      margin: 0 auto;
      font-size: 3rem;
    }
  }

  p {
    margin-bottom: 2em;
    line-height: 1.5em;
    font-size: 1em;
    margin-top:2em;
    display: block;
  }
  .label-heading {
    margin: 0 0 .2em;
    font-size: .85em;
    font-weight: 600;
    color: $blue;
    text-align: left;
    margin-bottom: 1em;
  }
  label {
    display: block;
    margin-bottom: 1em;
    + label {
      margin-top: .75em;
    }
  }
  input {
    width: 100%;
  }
  .recovery {
    margin: 1em auto;
    display: block;
    text-align: left;
    font-size: .85em;

    font-weight: 600;

    &:hover {
      color: $blue;
    }
  }

  .button {
    margin: 2em 1em 0;
  }

  .create {
    display: block;
    margin: 2em auto 0 auto;

    line-height: 1.6;

    a {
      display: inline-block;
      margin: 0 .5em;
      color: $blue;
      font-weight: 600;
    }
  }
</style>
